/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useAuthState } from "../../utilities/contexts/auth-state-context";
import { useIntercom } from "react-use-intercom";
import { useTranslation } from "react-i18next";
import OrganizationSubscriptionService from "../../utilities/services/organization-subscription-service";

export interface IntercomAuthCheckProps {
}

/**
 * A modal that shows up when the user's subscription was cancelled due to a failed payment.
 * 
 * @param props The properties
 * @returns {JSX.Element} The component
 */
const IntercomAuthCheck: React.FC<IntercomAuthCheckProps> = (props) => {
    const { state } = useAuthState();
    const { boot, shutdown } = useIntercom();
    var CryptoJS = require("crypto-js");
    const { t } = useTranslation();

    useEffect(() => {
        const initiateIntercom = async () => {
            if (state.authenticated && state.user?.roles && state.user.roles.length > 0 && state.organization && state.organization.plan?.label) {
                const customAttributes: any = {}
                customAttributes["Symmio Role"] = state.user.roles[0];
                customAttributes["Plan Type"] = t(state.organization.plan.label)
                if (state.user.roles?.includes("account_holder")) {
                    // Symmio Users, String structure -> 5/10
                    customAttributes["Symmio Users"] = `${state.organization.userCount}/${state.organization.userLimit}`
                    // Symmio Wellness Programs, String structure -> 5/10
                    customAttributes["Symmio Wellness Programs"] = `${state.organization.mySymmioLicenseCount}/${state.organization.mySymmioLicense}`
                    // Symmio Trial Days Left, String structure -> 5
                    // Calculate days left until renewDate
                    if (state.organization.id) {
                        const orgSub = await OrganizationSubscriptionService.getByOrganizationId(state.organization.id);
                        if (orgSub.length > 0 && orgSub[0].renewDate) {
                            const renewDate = new Date(orgSub[0].renewDate);
                            const today = new Date();
                            const timeDiff = renewDate.getTime() - today.getTime();
                            const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)); // Convert milliseconds to days
                            customAttributes["Symmio Trial Days Left"] = daysLeft > 0 ? daysLeft.toString() : "0";
                        }
                    }

                }
                const hmac = generateHmac();
                boot({
                    email: state.user?.email,
                    userHash: hmac,
                    customAttributes: customAttributes,
                })
            }
            else {
                shutdown()
            }
        }

        initiateIntercom()
    }, [state.authenticated, state.user?.roles, state.organization?.plan?.label])

    const generateHmac = () => {

        // Ensure message and secretKey are not empty
        if (!state.user?.email || !process.env.REACT_APP_INTERCOM_VERIFICATION) {
            return;
        }
        // Calculate HMAC using CryptoJS
        const hmac = CryptoJS.HmacSHA256(state.user.email, process.env.REACT_APP_INTERCOM_VERIFICATION).toString();

        return hmac;
    };

    return (
        <></>
    );
};

export default IntercomAuthCheck;